module.exports = function ($target) {
	console.log("comp036");
	let $consentBtn = $target.find("button#ticket-terms-consent");

	if ($consentBtn.length > 0) {
		let $checkoutLinks = $target.find('[data-role="checkout"]');

		$checkoutLinks.prop("disabled", true).addClass("disabled");

		$consentBtn.on("click", (e) => {
			console.log(e.target);
			$(e.target).closest(".row").addClass("d-none");
			$.each($checkoutLinks, function (index, value) {
				if ($(value).data("disabled") === false) {
					// it was enabled by the template before js, let's put it back that way
					$(value).prop("disabled", false).removeClass("disabled");
				}
			});
		});
	}
};
